import * as THREE from 'three'
import {loadTexture} from '../loaderUtils'
import SceneBase from './sceneBase'

class TestScene extends SceneBase{
  constructor(){
    super();
  }

  async loadModels(){
    if(this.bLoaded)
      return;

    
    // put directional light
    this.dirLight = new THREE.DirectionalLight( 0xffffff, 1);
    this.dirLight.position.set( -400, 300, 400 );
    this.dirLight.intensity = 4;
    this.sceneObjects.push(this.dirLight);
    this.rayTargetObjects = [];

    
    this.boxGeometry = new THREE.BoxGeometry();
    this.redMaterial = new THREE.MeshLambertMaterial( { color: 0x0000ff } );
    this.cubes = [];
    
    for(let x=0; x<10; x++){
      for(let y=0; y<10; y++){
        const cube = new THREE.Mesh( this.boxGeometry,this.redMaterial );
        cube.name = `cube_x${x}_z${y}`
        cube.touchable = true;
        cube.position.set(x*3, 0, y*3);
        this.cubes.push(cube);
        this.sceneObjects.push( cube );
        this.rayTargetObjects.push(cube);
      }
    }
    
    this.groundMaterial = new THREE.MeshLambertMaterial( {color: 0x333330});
    this.ground = new THREE.Mesh( this.boxGeometry, this.groundMaterial);
    this.ground.scale.set(100, 0.1, 100);
    this.ground.position.set(0, -0.05, 0);
    this.ground.movable = true;
    this.sceneObjects.push(this.ground);
    this.rayTargetObjects.push(this.ground);

    this.bLoaded = true;
  }

  destroy(){
    this.rayTargetObjects = [];

    for(let i=0; i<this.cubes.length; i++){
      this.cubes[i].dispose();
    }
    this.redMaterial.dispose();
    this.boxGeometry.dispose();
      
    this.dirLight.dispose();
    this.sceneObjects = [];

    this.bLoaded = false;
  }
}

export default TestScene;
